"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KNOWLEDGE = void 0;
const route_1 = require("../route");
exports.KNOWLEDGE = route_1.PROJECT.sub("/knowledge");
